import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient,withInterceptors  } from '@angular/common/http';
import { CustomPaginatorIntl } from './core/material/custom-paginator-intl';
import { MatPaginatorIntl } from '@angular/material/paginator';
//
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { provideTranslateService } from './core/i18n/translate.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
     provideRouter(routes),
     provideHttpClient(withInterceptors([authInterceptor])), 
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    provideTranslateService()
  ]
};
